/**
 * 브랜드 로고 락업 — "AI Interpreter CUPIA".
 *
 * 세 화면(랜딩·호스트·뷰어)이 같은 컴포넌트를 쓴다. 헤더마다 따로 조판하면
 * 자간·크기·색이 조금씩 어긋나고, 브랜드가 바뀔 때 고칠 곳이 늘어난다.
 *
 * 조판 의도:
 *  · 아이콘 + 워드마크 **한 덩어리**로 읽히게(아이콘은 정사각 배경에 얹어
 *    '마크' 로 보이게 한다 — 본문 아이콘과 구분되는 신호).
 *  · "AI Interpreter" 는 낮은 강조, **CUPIA** 는 높은 강조 + 넓은 자간.
 *    브랜드의 무게 중심이 CUPIA 이므로 시선이 거기 먼저 닿아야 한다.
 *  · 색은 DS 토큰만 쓴다(하드코딩 hex 금지 — 테마 전환에서 깨진다).
 *  · 자간·크기는 토큰 스케일을 따르므로 발표 모드에서도 함께 커진다.
 */

import { Languages } from 'lucide-react'

export function Brand({
  /** 부제(“실시간 다국어 통역 중계”) — 좁은 헤더에서는 생략한다 */
  subtitle,
  /**
   * 마크만 그린다(워드마크 생략) — 휴대폰 머리글 한 줄용
   * (lib/use-header-tools.ts). aria-label 은 그대로라 읽히는 이름은 같다.
   */
  compact = false,
  className = '',
}: {
  subtitle?: string
  compact?: boolean
  className?: string
}): React.ReactElement {
  return (
    <span
      className={`flex items-center gap-2 ${className}`}
      data-testid="brand"
      // 로고는 하나의 이름으로 읽혀야 한다 — 스크린리더가 조각내지 않게.
      aria-label="AI Interpreter CUPIA"
      role="img"
    >
      {/* 마크 — 정사각 배경 위의 아이콘 */}
      <span
        aria-hidden
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-[var(--radius-md)] bg-[var(--color-primary)] text-[var(--color-primary-foreground)]"
      >
        <Languages className="h-4 w-4" />
      </span>

      {/* 워드마크 — compact 면 생략(마크만 남긴다) */}
      {!compact && (
      <span aria-hidden className="flex flex-col leading-none">
        <span className="flex items-baseline gap-1.5">
          <span className="text-(length:--text-xs-size) font-medium uppercase tracking-[0.14em] text-[var(--color-muted-foreground)]">
            AI Interpreter
          </span>
          <span className="text-(length:--text-sm-size) font-bold tracking-[0.08em] text-[var(--color-foreground)]">
            CUPIA
          </span>
        </span>
        {subtitle && (
          <span className="mt-0.5 text-(length:--text-xs-size) text-[var(--color-muted-foreground)]">
            {subtitle}
          </span>
        )}
      </span>
      )}
    </span>
  )
}
